<template>
  <EmptyState
    :title="I18n.t('user.empty_states.no_results_title')"
    :text="I18n.t('user.empty_states.no_results_text')"
    data-testid="users-no-results"
  >
    <SfButtonDs
      variant="tertiary"
      icon-before="xmark"
      data-testid="users-no-results-clear"
      @click="clearFilters"
    >
      {{ I18n.t('user.filters.clear') }}
    </SfButtonDs>
  </EmptyState>
</template>

<script setup lang="ts">
import EmptyState from '@app/shared/vue/components/molecules/empty-state.vue'
import { SfButtonDs } from '@silverfin/ui-components'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useUsersListStore } from '@app/application/user-management/stores/users-list'

defineOptions({ name: 'UsersNoResults' })

const I18n = useI18n()

const { clearFilters } = useUsersListStore()
</script>
